import { useMemo, useContext, useEffect, useState } from "react";
import { Box, Hidden, CircularProgress, Popover } from '@material-ui/core'

import LanguageContext from "../../../contexts/LanguageContext"

import chatInfoIcon from "../../../images/chatInfoIcon.svg"

/*const DEFAULT_DATA = [
  { label: "0/4.9",    moyStartScore: 8,  moyEndScore: 25, progression: 17 },
  { label: "5/14.9",  moyStartScore: 20, moyEndScore: 30, progression: 10 },
  { label: "15/49.9", moyStartScore: 40, moyEndScore: 55, progression: 15 },
  { label: "50/84.9",  moyStartScore: 45, moyEndScore: 60, progression: 15 },
  { label: "85/94.9",  moyStartScore: 55, moyEndScore: 71, progression: 16 },
  { label: "95/100",   moyStartScore: 62, moyEndScore: 75, progression: 13 },
];*/


const widths = [10, 17, 23, 23, 17, 10]

const SCALE_STEPS = [25, 50, 75, 100];
const CHART_H = 127;
const BADGE_H = 30;

const ProgressionChart = ({ data, seuils }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  let viewExpectedLevel = false
  let expectedLevel = 0
  if (seuils && seuils?.find === true) {
    viewExpectedLevel = true
    expectedLevel = seuils?.after || 0
  }

  let maxValStart = useMemo(() => Math.max(...data.map((d) => d.moyStartScore)), [data]);
  let maxValEnd = useMemo(() => Math.max(...data.map((d) => d.moyEndScore)), [data]);
  let maxVal = Math.max(maxValStart, maxValEnd, expectedLevel)
  let MAX_VAL = useMemo(
    () => SCALE_STEPS.find((s) => s >= maxVal) ?? 100,
    [maxVal]
  );

  const ticks = useMemo(() => {
    const t = SCALE_STEPS.filter((s) => s <= MAX_VAL);
    if (!t.includes(0)) t.unshift(0);
    return t;
  }, [MAX_VAL]);

  let maxTick = ticks[ticks?.length - 1]


  let [beforePopover, setBeforePopover] = useState(false)
  let [afterPopover, setAfterPopover] = useState(false)
  let [canViewTooltips, setCanViewTooltips] = useState(false)

  useEffect(() => {
    let totalNbrStudents = 0
    data?.forEach((d) => {
      totalNbrStudents += d?.nbrStudents || 0
    })
    if (totalNbrStudents === 0) {
      setCanViewTooltips(false)
    } else {
      //on va regarder l'index de la barre qu'on veut pour sertir d'anchor aux tooltips, on préfère le plus à droite si possible
      for (let i=data?.length-1; i>=0; i--) {
        if (data[i]?.nbrStudents > 0) {
          setCanViewTooltips(i)
          break;
        }
      }
    }
  }, [data])


  return (
    <>
      <Box sx={{maxWidth:"1000px", userSelect:"none"}}>
        <Box sx={{display:"flex", justifyContent:"space-between", gap:"10px"}}>
          <Box sx={{fontSize:["14px", "16px"], color:"text.subTitle"}}>
            {languageValues?.adminDashboard?.mappingPage?.graph?.title[actLanguage]}
          </Box>
          <Hidden smDown>
            <Box sx={{display:"flex", gap:"10px", justifyContent:"flex-end", alignItems:"center"}}>
              <Box sx={{fontSize:"16px", color:"text.subTitle"}}>
                {languageValues?.adminDashboard?.mappingPage?.graph?.legends[actLanguage]}
              </Box>
              <Box
                onClick={() => {
                  if (canViewTooltips !== false) {
                    setBeforePopover(true)
                    document?.getElementById("anchorTooltipBefore_"+canViewTooltips)?.scrollIntoView({container:"nearest", inline:"center"})
                  }
                }}
                sx={{
                  padding: "7px 10px",
                  background: "#F3CCBD",
                  borderRadius: "12px",
                  fontSize:"12px",
                  opacity:canViewTooltips !== false ? 1 : 0.5,
                  cursor:canViewTooltips !== false && "pointer",
                }}
              >
                {languageValues?.adminDashboard?.mappingPage?.graph?.before[actLanguage]}
              </Box>
              <Box
                onClick={() => {
                  if (canViewTooltips !== false) {
                    setAfterPopover(true)
                    document?.getElementById("anchorTooltipAfter_"+canViewTooltips)?.scrollIntoView({container:"nearest", inline:"center"})
                  }
                }}
                sx={{
                  padding: "7px 10px",
                  background: "#E26438",
                  borderRadius: "12px",
                  fontSize:"12px",
                  color:"white",
                  opacity:canViewTooltips !== false ? 1 : 0.5,
                  cursor:canViewTooltips !== false && "pointer",
                }}
              >
                {languageValues?.adminDashboard?.mappingPage?.graph?.after[actLanguage]}
              </Box>
            </Box>
          </Hidden>
        </Box>
        <Box sx={{fontSize:["22px", "26px"], marginTop:["5px", "5px"]}}>
          {languageValues?.adminDashboard?.mappingPage?.graph?.subTitle[actLanguage]}
        </Box>
        <Hidden smUp>
          <Box sx={{marginTop:"5px", display:"flex", gap:"10px", justifyContent:"flex-start", alignItems:"center"}}>
            <Box sx={{fontSize:"13px", color:"text.subTitle"}}>
              {languageValues?.adminDashboard?.mappingPage?.graph?.legends[actLanguage]}
            </Box>
            <Box
              onClick={() => {
                if (canViewTooltips !== false) {
                  setBeforePopover(true)
                  document?.getElementById("anchorTooltipBefore_"+canViewTooltips)?.scrollIntoView({container:"nearest", inline:"center"})
                }
              }}
              sx={{
                padding: "6px 8px",
                background: "#F3CCBD",
                borderRadius: "12px",
                fontSize:"11px",
                opacity:canViewTooltips !== false ? 1 : 0.5,
                cursor:canViewTooltips !== false && "pointer",
              }}>
              {languageValues?.adminDashboard?.mappingPage?.graph?.before[actLanguage]}
            </Box>
            <Box
              onClick={() => {
                if (canViewTooltips !== false) {
                  setAfterPopover(true)
                  document?.getElementById("anchorTooltipAfter_"+canViewTooltips)?.scrollIntoView({container:"nearest", inline:"center"})
                }
              }}
              sx={{
                padding: "6px 8px",
                background: "#E26438",
                borderRadius: "12px",
                fontSize:"11px",
                color:"white",
                opacity:canViewTooltips !== false ? 1 : 0.5,
                cursor:canViewTooltips !== false && "pointer",
              }}
            >
              {languageValues?.adminDashboard?.mappingPage?.graph?.after[actLanguage]}
            </Box>
          </Box>
        </Hidden>
        <Box sx={{marginTop:["10px", "20px"], overflowX:"auto", overflowY:"hidden", scrollbarColor: "#FAF8F6 transparent",}}>

          {data?.length > 0 ? (
              <Box sx={{ paddingTop: BADGE_H+"px", width:"100%", minWidth:"600px", minHeight:"177px", boxSizing: "border-box",userSelect:"none" }}>
                {/* Chart area */}
                <Box sx={{ display: "flex", gap: "8px" }}>
                  {/* Y Axis */}
                  <Box sx={{ width: "30px", flexShrink: 0, position: "relative", height: CHART_H+"px" }}>
                    {ticks.map((t) => (
                      <span
                        key={t}
                        style={{
                          position: "absolute",
                          right: 4,
                          bottom: `${(t / MAX_VAL) * 100}%`,
                          fontSize: "11px",
                          color: "#999",
                          transform: "translateY(50%)",
                          lineHeight: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {t}%
                      </span>
                    ))}
                  </Box>

                  {/* Plot */}
                  <Box sx={{ flex: 1, position: "relative", height: CHART_H+"px" }}>
                    {/* Grid lines */}
                    <svg
                      style={{ position: "absolute", inset: 0, width: "100%", height: "100%", overflow: "visible" }}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {ticks.map((t) => (
                        <line
                          key={t}
                          x1="0" x2="100%"
                          y1={`${100 - (t / MAX_VAL) * 100}%`}
                          y2={`${100 - (t / MAX_VAL) * 100}%`}
                          stroke="currentColor"
                          strokeOpacity="0.15"
                          vectorEffect="non-scaling-stroke"
                        />
                      ))}
                    </svg>

                    {/* Bars */}
                    <Box sx={{ display: "flex", alignItems: "flex-end", height: "100%", position: "relative", zIndex: 1 }}>
                      {data.map((d, i) => {
                        let totalPx = 0
                        let topPx = 0
                        let botPx = 0
                        if (d.moyEndScore >= d.moyStartScore) {
                          totalPx = (d.moyEndScore / MAX_VAL) * CHART_H;
                        } else {
                          totalPx = (d.moyStartScore / MAX_VAL) * CHART_H;
                        }

                        topPx = ((d.moyEndScore - d.moyStartScore) / MAX_VAL) * CHART_H;
                        botPx = (d.moyStartScore / MAX_VAL) * CHART_H;


                        return (
                          <Box
                            key={i}
                            sx={{ width: widths[i]+"%", display: "flex", opacity:d?.nbrStudents>0?1:0, flexDirection: "column", alignItems: "center"}}
                          >
                            {/* Badge + bar stack */}
                            <Box sx={{ width: "calc(100% - 20px)", position: "relative", height: (totalPx + BADGE_H)+"px" }}>
                              {/* Delta badge */}
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: 0,
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  background: "#fff",
                                  border: "1.5px solid #222",
                                  borderRadius: "20px",
                                  fontSize: "13px",
                                  fontWeight: 500,
                                  padding: "3px 6px",
                                  whiteSpace: "nowrap",
                                  color: "#222",
                                  zIndex: 2,
                                }}
                              >
                                {d.progression >= 0 && "+"}
                                {Math.round(d.progression * 100) / 100}
                                %
                              </Box>

                              {/* Inner bar */}
                              <Box
                                sx={{
                                  position: "absolute",
                                  bottom: 0,
                                  left: 0,
                                  right: 0,
                                  height: totalPx+"px",
                                }}
                              >
                                {/* Top segment (dark, rounded top only) */}
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: totalPx+"px",
                                    background: "#D85A30",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "center",
                                  }}
                                />

                                <Box
                                  id={"anchorTooltipAfter_"+i}
                                  sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: topPx+"px",
                                    background: "transparent",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#fff",
                                  }}
                                >
                                  {parseInt(d.moyEndScore)}%
                                </Box>

                                {/* Bottom segment (light, full rounded) */}
                                <Box
                                  id={"anchorTooltipBefore_"+i}
                                  sx={{
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    height: botPx+"px",
                                    background: "#F5C4B3",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#545455",
                                  }}
                                >
                                  {parseInt(d.moyStartScore)}%
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                    {/* Expected level */}

                    {viewExpectedLevel &&
                      <Box sx={{
                        position:"absolute",
                        bottom:"calc("+(expectedLevel / maxTick)*100+"% - 1px)",
                        width:"100%",
                        borderBottom:"2px dashed rgba(0,0,0,0.5)",
                        paddingBottom:"2px",
                        fontSize:"12px",
                        color:"black",
                      }}>
                        {languageValues?.adminDashboard?.mappingPage?.graph?.expectedLevel[actLanguage]} {expectedLevel}%
                      </Box>
                    }

                  </Box>
                </Box>


                {/* X labels */}
                <Box sx={{ display: "flex", marginLeft: "38px" }}>
                  {data.map((d, i) => (
                    <Box
                      key={i}
                      sx={{
                        width: `${widths[i]}%`,
                        flexShrink: 0,
                        textAlign: "center",
                        marginTop: "7px",
                        fontSize: "12px",
                        color: "#888",
                      }}
                    >
                      {d.label}
                    </Box>
                  ))}
                </Box>
              </Box>

          ) : (
            <Box sx={{minHeight:"177px", display:"flex", justifyContent:"center", alignItems:"center"}}>
              <CircularProgress size="50px" sx={{'color': 'black'}} />
            </Box>
          )}
        </Box>
      </Box>

      {canViewTooltips !== false &&
        <>
          <Popover
            open={beforePopover}
            anchorEl={document.getElementById("anchorTooltipBefore_"+canViewTooltips)}
            onClose={() => { setBeforePopover(false) }}
            anchorOrigin={{
              vertical: "center",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Box sx={{padding:"10px", width:"170px"}}>
              <Box sx={{display:"flex", justifyContent:"flex-end"}}>
                <img src={chatInfoIcon} style={{width:"15px", height:"15px"}} />
              </Box>
              <Box sx={{padding:"0px 10px 10px 10px", display:"flex", flexDirection:"column", alignItems:"center", gap:"10px"}}>
                <Box sx={{width:"85px", height:"100px", borderRadius:"10px", border:"1px solid grey", position:"relative"}}>
                  <Box sx={{
                    position:"absolute",
                    bottom:0,
                    width:"100%",
                    height:parseInt(data[canViewTooltips]?.moyStartScore)+"%",
                    borderRadius:"9px",
                    background:"#F3CCBD",
                    color:"#545455",
                    fontSize:"14px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                  }}>
                    {parseInt(data[canViewTooltips]?.moyStartScore)}%
                  </Box>
                </Box>
                <Box sx={{textAlign:"center", color:"text.black", fontSize:"15px", lineHeight:"125%", whiteSpace:"pre-line"}}>
                  {languageValues?.adminDashboard?.mappingPage?.graph?.knowledgeBeforeLegend[actLanguage]}
                </Box>
                <Box sx={{textAlign:"center", color:"text.subTitle", fontSize:"12px"}}>
                  {languageValues?.adminDashboard?.mappingPage?.graph?.legendSubTitle[actLanguage]}
                </Box>
              </Box>
            </Box>
          </Popover>

          <Popover
            open={afterPopover}
            anchorEl={document.getElementById("anchorTooltipAfter_"+canViewTooltips)}
            onClose={() => { setAfterPopover(false) }}
            anchorOrigin={{
              vertical: "center",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Box sx={{padding:"10px", width:"170px"}}>
              <Box sx={{display:"flex", justifyContent:"flex-end"}}>
                <img src={chatInfoIcon} style={{width:"15px", height:"15px"}} />
              </Box>
              <Box sx={{padding:"0px 10px 10px 10px", display:"flex", flexDirection:"column", alignItems:"center", gap:"10px"}}>
                <Box sx={{width:"85px", height:"100px", borderRadius:"10px", border:"1px solid grey", position:"relative"}}>
                  <Box sx={{
                    position:"absolute",
                    bottom:0,
                    width:"100%",
                    height:parseInt(data[canViewTooltips]?.moyEndScore)+"%",
                    borderRadius:"9px",
                    background:"#E26438",
                    color:"white",
                    fontSize:"14px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                  }}>
                    {parseInt(data[canViewTooltips]?.moyEndScore)}%
                  </Box>
                </Box>
                <Box sx={{textAlign:"center", color:"text.black", fontSize:"15px", lineHeight:"125%", whiteSpace:"pre-line"}}>
                  {languageValues?.adminDashboard?.mappingPage?.graph?.knowledgeAfterLegend[actLanguage]}
                </Box>
                <Box sx={{textAlign:"center", color:"text.subTitle", fontSize:"12px"}}>
                  {languageValues?.adminDashboard?.mappingPage?.graph?.legendSubTitle[actLanguage]}
                </Box>
              </Box>
            </Box>
          </Popover>
        </>
      }
    </>
  );
}

export default ProgressionChart
